export default __webpack_public_path__ + "static/img-finish-products-425801840b7d7284a6ae14f4a46bf995.webp";